import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col, Button
} from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import moment from "moment";
import GenerateExcelReportOperationalDiary from "../ExportFiles/GenerateExcelReportOperationalDiary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf, faSave } from "@fortawesome/free-solid-svg-icons";

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const TableOperationsDiary = ({ title, reactTableData, ReactTableActions, radiopharmacyDose, starterDate, endDate }) => {
    const { t } = useTranslation('common');

    const [dataRows, setDataRows] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);
    const [codeServicesToDisplay, setCodeServicesToDisplay] = useState([]);

    useEffect(() => {
        codeServices();
        console.log("datosTabla", reactTableData);
    }, [])


    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            dataRows,
            result.source.index,
            result.destination.index,
        );
        setDataRows(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setDataRows(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const codeServices = () => {
        if (radiopharmacyDose !== null && radiopharmacyDose !== undefined) {
            let codeDose = [];
            radiopharmacyDose.forEach(element => {
                if (element.codigo !== null && element.codigo !== undefined)
                    codeDose.push({ ['code_service']: element.codigo, ['id_code_service']: element.id_radiofarmacia_dosisinfo })
            });
            console.log("ServicesCodes", codeDose)
            setCodeServicesToDisplay(codeDose);
        }
    }

    const searchService = (code) => {
        if (code !== null && code !== undefined) {
            let service = radiopharmacyDose.filter((doseServices) => doseServices.codigo === code);
            return service[0].estudio;
        }
    }

    const tableConfig = {
        isEditable,
        isSortable,
        withDragAndDrop,
        withPagination,
        manualPageSize: [30, 60, 90, 120, 150],
        /*
        withSearchEngine,
        placeholder: 'Buscar Medicamento',
        useActions: true,
        actions: (data) => ReactTableActions({ data, Callback,medicinesUnit }),*/
    };

    const getDataToExcel = (data, starterDate, endDate) => {
        GenerateExcelReportOperationalDiary.exportExcel(data, starterDate, endDate);
    }

    const saveDataDiario = async () => {

        let fechaInicial = moment(starterDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        
        let dataSend = {
            fecha_inicio: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            data_diario: dataRows
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reportes/guardar-registro-diario-operaciones', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error en el Servidor');
            }
        }).then((data) => {
            console.log(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const columnsData = [
        {
            Header: () => <div style={{ minWidth: '250px', maxWidth: '250px' }}>Paciente</div>,
            accessor: 'nombre_paciente',
            disableGlobalFilter: true,
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="fecha_atencion"
                        disabled={true}
                        label=""
                        defaultValue={row.value}
                        className='medical-material-form__field'
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '100px', maxWidth: '100px' }}>Documento del Paciente</div>,
            accessor: 'num_documento',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="num_documento"
                        disabled={true}
                        label=""
                        defaultValue={row.value}
                        className='medical-material-form__field'
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '10%' }}>Fecha de Atención</div>,
            accessor: 'fecha_cita',
            disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="fecha_atencion"
                        disabled={true}
                        label=""
                        defaultValue={row.cell.row.original.fecha_cita != null ? moment(row.cell.row.original.fecha_cita).format("DD/MM/YYYY") : null}
                        className='medical-material-form__field'
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '4%' }}>Edad</div>,
            accessor: 'edad',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="edad_paciente"
                        disabled={true}
                        label=""
                        defaultValue={`${row.cell.row.original.edad}${row.cell.row.original.unidad_medida_edad}`}
                        className='medical-material-form__field'
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '50px', maxWidth: '50px' }}>CUPS</div>,
            accessor: 'cups_servicio',
            disableGlobalFilter: true,
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="fecha_atencion"
                        disabled={true}
                        label=""
                        defaultValue={row.value}
                        className='medical-material-form__field'
                    />
                </div>
            )
        },
        /* {
            Header: () => <div style={{ minWidth: '5%' }}>Código del Estudio</div>,
            accessor: 'codigo_estudio',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="codigo_estudio"
                        select
                        label=""
                        value={dataRows[row.cell.row.index].codigo_estudio}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            let newArr = [...dataRows];
                            newArr[row.cell.row.index]['codigo_estudio'] = event.target.value;
                            newArr[row.cell.row.index]['estudio'] = searchService(event.target.value);
                            setDataRows(newArr);
                        }}
                        style={{ minWidth: '100%', maxWidth: 10 }}
                    >
                        {codeServicesToDisplay.map((codeService) => (
                            <MenuItem key={codeService.id_code_service} value={codeService.code_service}>
                                {codeService.code_service}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )
        }, */
        /* {
            Header: () => <div style={{ minWidth: '200px', maxWidth: '200px' }}>Estudio</div>,
            accessor: 'estudio',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="estudio"
                        label=""
                        disabled={true}
                        className='medical-material-form__field'
                        value={dataRows[row.cell.row.index].estudio}
                    />
                </div>
            )
        }, */
        {
            Header: () => <div style={{ minWidth: '400px', maxWidth: '400px' }}>Servicio</div>,
            accessor: 'nombre_servicio',
            disableGlobalFilter: true,
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="fecha_atencion"
                        disabled={true}
                        label=""
                        defaultValue={row.value}
                        className='medical-material-form__field'
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '5%' }}>Actividad en MBq</div>,
            accessor: 'actividad_mbq',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="actividad_mbq"
                        type="number"
                        label=""
                        /* value={dataRows[row.cell.row.index].actividad_mbq} */
                        defaultValue={dataRows[row.cell.row.index].actividad_mbq}
                        className='medical-material-form__field'
                        onBlur={(event) => {
                            let newArr = [...dataRows];
                            newArr[row.cell.row.index]['actividad_mbq'] = event.target.value;
                            setDataRows(newArr);
                        }}
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '5%' }}>Embarazo</div>,
            accessor: 'embarazo',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="embarazo"
                        select
                        label=""
                        disabled={row.cell.row.original.sexo == 'Femenino' ? false : true}
                        value={dataRows[row.cell.row.index].embarazo !== undefined && dataRows[row.cell.row.index].embarazo !== null ? dataRows[row.cell.row.index].embarazo : "No"}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            let newArr = [...dataRows];
                            newArr[row.cell.row.index]['embarazo'] = event.target.value;
                            setDataRows(newArr);
                        }}
                        style={{ minWidth: '100%', maxWidth: 10 }}
                    >
                        <MenuItem key={0} value={'No'}>No</MenuItem>
                        <MenuItem key={1} value={'Si'}>Si</MenuItem>
                    </TextField>
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '6%' }}>Observacion</div>,
            accessor: 'observacion',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="observacion"
                        label=""
                        disabled={false}
                        /* value={dataRows[row.cell.row.index].observacion} */
                        defaultValue={dataRows[row.cell.row.index].observacion}
                        className='medical-material-form__field'
                        onBlur={(event) => {
                            let newArr = [...dataRows];
                            newArr[row.cell.row.index]['observacion'] = event.target.value;
                            setDataRows(newArr);
                        }}
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '20px' }}>Peso</div>,
            accessor: 'peso',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="peso"
                        label=""
                        disabled={true}
                        defaultValue={row.value}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            console.log(event.target.value);
                        }}
                    />
                </div>
            )
        },
        {
            Header: () => <div style={{ minWidth: '20px' }}>Talla</div>,
            accessor: 'talla',
            Cell: row => (
                <div className="text-center" >
                    <TextField
                        id="talla"
                        label=""
                        disabled={true}
                        defaultValue={row.value}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            console.log(event.target.value);
                        }}
                    />
                </div>
            )
        }
    ];

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={dataRows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                    <br />
                    {
                        dataRows.length > 0 ? <Fragment>
                            <Tooltip title="Exportar Excel">
                                <Button
                                    style={{ marginTop: 10, marginRight: 10 }}
                                    variant="contained"
                                    color="success"
                                    onClick={() => {
                                        getDataToExcel(dataRows, starterDate, endDate);
                                    }}
                                >
                                    <FontAwesomeIcon style={{ fontSize: '20px' }} icon={faFileExcel} />
                                </Button>
                            </Tooltip>

                            {
                                /*
                                <Tooltip title="Guardar Informe de Diario de Operaciones">
                                <Button
                                    style={{ marginTop: 10, marginRight: 10 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        saveDataDiario();
                                    }}
                                >
                                    <FontAwesomeIcon style={{ fontSize: '20px' }} icon={faSave} />
                                </Button>
                            </Tooltip>    
                                
                                
                                */
                            }
                            
                        </Fragment>
                            : null
                    }
                </CardBody>
            </Card>
            <br />

        </Col>
    );
};

TableOperationsDiary.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default TableOperationsDiary;
